"use strict";

const TouchscreenEmail = () => {
    const init = () => {
        if($('form').length > 0) {
            $(document).ajaxSuccess(function (xhr) {
                if (typeof xhr.target.nodeName !== 'undefined' && xhr.target.nodeName === 'FORM') {
                    $(xhr.target).find('.alert-success').addClass('show');
                    $(xhr.target).find('.alert-danger').removeClass('show');
                }
            });
            $(document).ajaxError(function (xhr) {
                if (typeof xhr.target.nodeName !== 'undefined' && xhr.target.nodeName === 'FORM') {
                    $(xhr.target).find('.alert-danger').addClass('show');
                    $(xhr.target).find('.alert-success').removeClass('show');
                }
            });
        }
    };

    return {
        init:init
    };
};

export default TouchscreenEmail;